
<context-display :context="context">
  <template #simple>
    <p>{{displayText}}</p>
  </template>
  <template #workarea>
    <crayon color="Blue">Indexed</crayon>
  </template>
</context-display>
